const base_url = process.env.NEXT_PUBLIC_BASE_URL;

export const LOGIN_API = `${base_url}/api/user/login`;
export const LOGOUT_API = `${base_url}/api/user/logout`;
export const REG_WITH_EMAIL_API = `${base_url}/api/user/registerwithemail`;
export const REG_WITH_NUMBER_API = `${base_url}/api/user/registerwithnumber`;
export const VERIFY_USER_API = `${base_url}/api/user/verifyUser`;
export const RESET_PASSWORD_API = `${base_url}/api/user/resetPassword`;
export const RECOVER_PASSWORD_WITH_EMAIL_API = `${base_url}/api/user/resetPasswordMail`;
export const RECOVER_PASSWORD_WITH_NUMBER_API = `${base_url}/api/user/resetPasswordSMS`;
export const RESEND_OTP_WITH_EMAIL_API = `${base_url}/api/user/resendotp-mail`;
export const RESEND_OTP_WITH_NUMBER_API = `${base_url}/api/user/resendotp-sms`;
export const VERIFY_OTP_API = `${base_url}/api/user/verify-otp`;
export const VALIDATE_LOGIN_TOKEN_API = `${base_url}/api/user/validate-token`;
